import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Projects from './pages/Projects';
import Resume from './pages/Resume';        // import About
import Contact from './pages/Contact';    // import Contact

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-100">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/resume" element={<Resume  />} />        {/* Add route */}
          <Route path="/contact" element={<Contact  />} />    {/* Add route */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
